import React, {useEffect} from "react";
import {Typography, Box, IconButton} from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ChevronRight";
import ChatBackArrow from "@assets/icons/chatBackArrow";
import ResolvedIcon from "@assets/icons/resolvedIcon";
import {useSelector} from "react-redux";
import {RootState} from "@store/store.tsx";
import AudioAndVideoCall from "./chatHeader/audioAndVdeoCall";
import { useHasPolicy } from "@config/useHasPolicy";
import { PolicyEnum } from "@config/policyEnum";

interface ChatHeaderProps {
    ticketId: string | undefined;
    onBackClick: () => void;
    setResolvedDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    status:string | null;
    id:string | undefined;
    setCustomStatus: React.Dispatch<React.SetStateAction<string>>;
    customStatus: string;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
                                                   ticketId,
                                                   onBackClick,
                                                   setResolvedDrawer,
                                                   status,
                                                   id,
                                                   setCustomStatus,
                                                   customStatus
                                               }) => {
    const {customStatuses} = useSelector((state: RootState) => state.config);
    const {ticketDetails} = useSelector((state: RootState) => state.tickets);
    const showResolvedAction = useHasPolicy(PolicyEnum.VIEW_CHAT_RESOLVED_ACTION);
    const editResolvedAction = useHasPolicy(PolicyEnum.EDIT_CHAT_RESOLVED_ACTION);
    useEffect(() => {
        if (ticketDetails?.request?.customStatusId) {
            const status = customStatuses?.find(
                (status) => status?.id == ticketDetails?.request?.customStatusId
            );
            if (status) {
                setCustomStatus(status?.endUserLabel);
            }
        }
    }, [ticketDetails]);
    return (
        <Box
            className="shadow md:shadow-none"
            sx={{
                borderRadius: 0,
                width: "100%",
                maxwidth: "100vw",
                backgroundColor: "#fff",
                boxSizing: "border-box",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: {xs: "12px 10px", sm: "12px 16px 12px"},
            }}
        >
            <Box sx={{display: "flex", alignItems: "center"}}>
                <Box className="flex flex-col">
                    <Box className="flex items-center">
                        <Box
                            className="flex items-center cursor-pointer"
                            onClick={onBackClick}
                        >
                            <Typography>
                                <ChatBackArrow/>
                            </Typography>
                            <Typography
                                variant="subtitle2"
                                component="div"
                                sx={{color: "primary.main",fontSize:"14px", fontWeight:400}}
                            >
                                Ticket List
                            </Typography>
                        </Box>
                        <ArrowRightIcon/>
                        <Typography variant="subtitle2" component="div" sx={{mr: "auto",fontSize:"14px", fontWeight:400}}>
                            Ticket ID : <span className={'capitalize'}>{ticketId}</span>
                        </Typography>
                    </Box>
                    <Box className="flex items-center">
                        <Typography variant="subtitle2" className="!pl-3 !pr-2">
                            Status: {id==="new" ? id : customStatus}
                        </Typography>
                        {showResolvedAction &&
                        <IconButton
                            aria-label="resolved-icon"
                            className={`cursor-pointer ${customStatus === "Resolved" || status === "closed" || id==="new" && "opacity-50"} `}
                            onClick={() => setResolvedDrawer(true)}
                            disabled={customStatus === "Resolved" || status === "closed" || id==="new" || !editResolvedAction}
                        >
                            <ResolvedIcon/>
                        </IconButton>}
                    </Box>
                </Box>
            </Box>
          <AudioAndVideoCall customStatus={customStatus} ticketId={ticketId}/>
        </Box>
    );
};

export default ChatHeader;
